import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React, { useState } from "react"
import { View, StyleSheet, TouchableOpacity, ScrollView } from "react-native"
import { ActivityIndicator, Checkbox } from "react-native-paper"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"
import { PatientFollowUpService } from "@Services/PatientFollowUp.Service"
import { defaultAgreementPayload, handleCheckedProfessionalStatus, handleSetCheckedProfessional } from "./Logic"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { Spacer } from "@Components/Space"
import { Button } from "@Components/CustomButton/Button"
import { isNull } from "lodash"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"

export const NewProfList = ({ data, loading, setUpdateList, payload, setPayload }) => {
    const user = useRecoilValue(userAtom)
    const [sending, setSending] = useState(false)
    const professionals = data?.filter((item) => isNull(item.isAcceptedByPatient) && !item?.isMedecinTraitant)

    console.log({ data })
    const handleGiveAgreement = () => {
        const finalPayload = {
            payload: {
                professionalIds: payload,
                isRevocation: 0
            },
            patientId: user?.id
        }
        setSending(true)

        PatientFollowUpService.postNewProfessionalHealthAgreement({ ...finalPayload })
            .then(() => {
                setUpdateList((prev) => !prev)
                setPayload(defaultAgreementPayload)
                ShowToast({
                    type: "success",
                    message: "L'accord a été donné avec succès"
                })
                setSending(false)
            })
            .catch((error) => {
                setSending(false)
                console.log({ error })
                ShowToast({
                    type: "error",
                    message: message.serverError
                })
            })
    }

    const handleCheckBoxPress = (professionalId) => {
        handleSetCheckedProfessional({
            setPayload,
            newProfessionalId: professionalId
        })
    }

    const isLoading = loading
    const disabledBtn = payload?.professionalIds?.length === 0 || loading || sending

    return (
        <View>
            {isLoading ? (
                <ActivityIndicator color={baseColors.green.primary} style={{ padding: 30 }} size={"large"} />
            ) : (
                <ScrollView keyboardShouldPersistTaps={"handled"} nestedScrollEnabled>
                    <BreeSerifText
                        style={{ marginBottom: 10, textAlign: "center" }}
                        color={baseColors.green.primary}
                        fontSize={18}
                    >
                        Liste des professionnels de santé à valider
                    </BreeSerifText>

                    <Spacer height={10} />

                    <OpenSansText
                        style={{
                            fontSize: 12,
                            color: baseColors.orange.primary,
                            textAlign: "center"
                        }}
                    >
                        Donner mon accord pour que mon parcours soit lu par des professionnels de santé.
                    </OpenSansText>

                    <Spacer height={20} />

                    <View style={{}}>
                        {professionals?.map((professional, i) => (
                            <TouchableOpacity
                                onPress={() => handleCheckBoxPress(professional.id)}
                                key={i}
                                style={styles.content}
                            >
                                <View style={{ flex: 0.9 }}>
                                    <OpenSansText
                                        numberOfLines={1}
                                        style={{ paddingRight: 10 }}
                                        defaultFontFamily={baseFontFamily.OpenSansBold}
                                        fontSize={12}
                                    >
                                        {professional.fullName}
                                    </OpenSansText>

                                    {professional?.isMedecinTraitant && (
                                        <OpenSansText
                                            numberOfLines={1}
                                            style={{
                                                paddingRight: 10,
                                                color: baseColors.green.primary
                                            }}
                                            defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                            fontSize={12}
                                            center
                                        >
                                            (Mon médecin traitant)
                                        </OpenSansText>
                                    )}
                                </View>

                                <SwitchContent
                                    disabled={sending}
                                    checked={handleCheckedProfessionalStatus({
                                        payload,
                                        setPayload,
                                        professionamId: professional.id
                                    }) === "checked"}
                                    handleCheck={() => handleCheckBoxPress(professional.id)}
                                    checkBoxColor={
                                        professional.isAcceptedByPatient === 1
                                            ? baseColors.orange.primary
                                            : baseColors.green.primary
                                    }
                                />
                            </TouchableOpacity>
                        ))}
                    </View>
                </ScrollView>
            )}

            {!isLoading && professionals?.length > 0 && (
                <Button
                    loading={sending}
                    text="Envoyer l'accord"
                    width={"70%"}
                    onPress={handleGiveAgreement}
                    disabled={disabledBtn}
                    backgroundColor={baseColors.green.primary}
                    labelColor="white"
                    marginTop={20}
                    marginBottom={10}
                    style={{ marginBottom: 150, marginTop: 100 }}
                />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    divider: { height: 1, backgroundColor: baseColors.green.primary, width: "90%", alignSelf: "center" },
    titleStyle: {
        marginBottom: 10,
        fontSize: RFValue(14),
        fontFamily: baseFontFamily.OpenSansRegular,
        color: baseColors.green.primary
    },
    descriptionStyle: {
        fontSize: RFValue(16),
        lineHeight: 30,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black
    },
    content: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10
    }
})
